import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  rerunCheck: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecks.mergeCheckList.rerunCheck',
    description: 'Text for button to rerun check',
    defaultMessage: 'Rerun',
  },
  onMergeOpenPrDescription: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecks.mergeCheckList.onMergeOpenPrDescription',
    description: 'Description for checks that will run on merge for an open PR',
    defaultMessage: 'These will run on merge:',
  },
  onMergeClosedPrDescription: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecks.mergeCheckList.onMergeClosedPrDescription',
    description: 'Description for checks that ran on merge for a closed PR',
    defaultMessage: 'On-merge checks:',
  },
  branchIconLabel: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecks.mergeCheckList.branchIconLabel',
    description:
      'Label for icon indicating the merge check is running on a specific branch',
    defaultMessage: 'Merge check running on specific branch',
  },
  failedToRetry: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecks.mergeCheckList.failedToRetry',
    description: 'Error message when retrying a check fails',
    defaultMessage: 'Failed to retry custom merge check',
  },
  noRepositoryWrite: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecks.mergeCheckList.noRepositoryWrite',
    description:
      'Error message when user does not have write permission to the repository',
    defaultMessage:
      'You do not have the necessary permissions to rerun checks.',
  },
});
